<template>
  <div id="cover" :style="coverStyle">
    <div class="cover">
      <h1>Choisissez votre Suite</h1>
        <ul id="steps">
          <transition-group name="append-from-right">
            <li :class="{current: key === index}" v-for="(item, key) in steps" :key="item.step" :item="item" :index="key">
              <a :href="item.link">
                <span></span>
                <h3>{{item.step}}</h3>
                <h4>{{item.title}}</h4>
              </a>
            </li>
          </transition-group>
        </ul>
    </div>
    <div class="gradientslider"></div>
  </div>
</template>

<script>
export default {
  name: 'cover',
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      steps: [
        {
          link: 'http://638ad42bcb.testurl.ws/mihotel/step1.html',
          step: 'étape 1',
          title: 'Votre suite',
        },
        {
          link: 'http://638ad42bcb.testurl.ws/mihotel/step2.html',
          step: 'étape 2',
          title: 'Votre suite',
        },
        {
          link: 'http://638ad42bcb.testurl.ws/mihotel/step3.html',
          step: 'étape 3',
          title: 'Vos extras',
        },
        {
          link: 'http://638ad42bcb.testurl.ws/mihotel/step4.html',
          step: 'étape 4',
          title: 'Votre réservation',
        },
      ],
    };
  },
  computed: {
    coverStyle() {
      if (this.$store.state.homeSlider.roomPictures.length === 0) {
        return null;
      }
      const pic = this.$store.state.homeSlider.roomPictures[this.$store.state.homeSlider.currentIndex];
      return `background-image: url(${pic.absolute_path}?w=1905&h=700&crop-to-fit)`;
    },
  },
  async mounted() {
    await this.$store.dispatch('homeSlider/fetchCheck', { lang: this.$store.state.lang.currentLang });
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/parts/cover.vue